import React, { useState, useEffect } from 'react';
import { 
  Chart as ChartJS, 
  CategoryScale, 
  LinearScale, 
  LineElement,
  PointElement,
  Title, 
  Tooltip, 
  Legend 
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import axios from 'axios';
import '../styles/SalesCharts.css';

// Registrar componentes de Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const SupervisorCumulativeSalesChart = ({ selectedPOS }) => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchYearlySalesData = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        // Build URL with POS filter using same parameter as other working endpoints
        const params = new URLSearchParams();
        if (selectedPOS && selectedPOS !== 'all') {
          params.append('pos_id', selectedPOS);
        }
        
        const url = `/api/supervisors/yearly-sales-chart${params.toString() ? `?${params.toString()}` : ''}`;
        
        console.log('Obteniendo datos de ventas anuales acumuladas desde:', url);
        
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        
        setChartData(response.data);
        setError(null);
      } catch (error) {
        console.error('Error al obtener datos de ventas anuales acumuladas:', error);
        
        // Crear datos vacíos para el año actual
        const currentYear = new Date().getFullYear();
        
        // Crear etiquetas para cada mes
        const months = [
          'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
          'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];
        
        // Crear arrays de datos vacíos
        const monthlyTotals = Array(12).fill(0);
        const cumulativeTotals = Array(12).fill(0);
        
        // Crear datos de gráfica vacíos
        const emptyChartData = {
          labels: months,
          year: currentYear,
          monthlyData: {
            totals: monthlyTotals
          },
          cumulativeData: {
            totals: cumulativeTotals
          }
        };
        
        setChartData(emptyChartData);
        setError(null);
      } finally {
        setLoading(false);
      }
    };

    fetchYearlySalesData();
  }, [selectedPOS]);

  if (loading) {
    return <div className="charts-loading">Cargando gráfica de ventas acumuladas...</div>;
  }

  if (!chartData) {
    return <div className="charts-empty"></div>;
  }

  // Configuración para la gráfica de línea (ventas acumuladas)
  const lineChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: `Ventas Acumuladas ${chartData.year}`,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            return '$' + value.toFixed(2);
          }
        }
      }
    }
  };

  const lineChartData = {
    labels: chartData?.labels || [],
    datasets: [
      {
        label: 'Ventas Acumuladas',
        data: chartData?.cumulativeData?.totals || Array(12).fill(0),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        tension: 0.1,
      },
    ],
  };

  return (
    <div className="chart-wrapper">
      <h3>Ventas Acumuladas (Enero a Diciembre)</h3>
      <div className="chart-container">
        <Line options={lineChartOptions} data={lineChartData} />
      </div>
    </div>
  );
};

export default SupervisorCumulativeSalesChart;
